<template>
  <div :class="`fnss-card-item vux-1px-b fnss-card-item-${type}`">
    <template v-if="type === 'vertical'">
      <slot></slot>
    </template>
    <template v-else>
      <div class="fnss-card-item-left">
        {{ term }}
      </div>
      <div class="fnss-card-item-right">
        <slot></slot>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    term: {
      type: String
    },
    type: {
      type: String,
      default: "horizontal"
    }
  }
};
</script>
